<template>
  <div>
    <div class="gid-comment rounded-lg p-2">
      <div>
        <small>
          {{ value.number }} - {{ value.title }}
          &gt;
          {{ value.subject }}
        </small>
      </div>
      <div>
        <small class="text-muted">
          {{ value.from }}
          <br />
          {{ value.to }}
        </small>
        <b-button
          @click="toggleShowContent"
          size="sm"
          variant="link"
          class="gid-feed__details p-0 align-baseline text-secondary"
        >
          {{ buttonText }}
        </b-button>
      </div>
      <iframe
        v-if="showContent"
        ref="iframeRef"
        :id="this.value.number"
        :srcdoc="formattedContent"
        class="w-100 border rounded"
        @load="adjustIframeHeight"
      ></iframe>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { RequestQueryBuilder, CondOperator } from '@dataui/crud-request';
import { TicketStatusEnum } from '@gid/models';

export async function fetchTicketArticles({
  job: {
    job: { name: jobName },
  },
}) {
  const queryString = RequestQueryBuilder.create({
    filter: [
      {
        field: 'jobs.name',
        operator: CondOperator.EQUALS,
        value: jobName,
      },
      {
        field: 'status',
        operator: CondOperator.NOT_EQUALS,
        value: TicketStatusEnum.X,
      },
    ],
    sort: [{ field: 'messages.created_at', order: 'ASC' }],
  }).query();

  const tickets = await axios.get(`/data-api/ticket?${queryString}`);
  if (!tickets.data.length) {
    return [];
  }
  const ticketItems = [];
  tickets?.data?.map((ticket) => {
    ticket?.messages.map((message) => {
      ticketItems.push({
        time: new Date(message?.createdAt),
        value: {
          number: ticket?.id,
          title: ticket?.title,
          subject: message?.subject,
          content: message?.content,
          from: message?.from,
          to: message?.to,
          type: message?.type,
        },
      });
    });
  });
  return ticketItems;
}

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      showContent: false,
    };
  },
  computed: {
    formattedContent() {
      // Regular expression to detect HTML tags
      const pattern = /<[^>]+>/g;
      if (!pattern.test(this.value.content)) {
        return this.value.content.replace(/\n/g, '<br>');
      }
      return this.value.content;
    },
    buttonText() {
      return this.showContent
        ? this.$t('tickets.hide_content')
        : this.$t('tickets.show_content');
    },
  },
  methods: {
    adjustIframeHeight() {
      this.$nextTick(() => {
        const iframe = this.$refs.iframeRef;
        if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
          iframe.style.height =
            iframe.contentWindow.document.documentElement.scrollHeight +
            10 +
            'px';
        }
      });
    },
    toggleShowContent() {
      this.showContent = !this.showContent;
    },
  },
};
</script>
